import { IActionOptions } from '@interfaces/IActionOptions';
import { IFormErrors } from '@interfaces/IFormsErrors';
import { IPeriodResults } from '@interfaces/IPeriodResults';
import { Action } from '@ngrx/store';

export enum EStudentsPerformanceActions {
  GetStudentsPerformancePeriodRequest = '[Students Performance] Get Student Performance Period Request',
  GetStudentsPerformancePeriodSuccess = '[Students Performance] Get Student Performance Period Success',
  GetStudentsPerformancePeriodFailure = '[Students Performance] Get Student Performance Period Failure',
  ClearStudentsPerformancePeriod = '[Students Performance] Clear Students Performance Period',

  SetProbationary = '[Student Performance] Set Probationary',
}

export class GetStudentsPerformancePeriodRequest implements Action {
  public readonly type =
    EStudentsPerformanceActions.GetStudentsPerformancePeriodRequest;

  constructor(public periodId: number, public options?: IActionOptions) {}
}

export class GetStudentsPerformancePeriodSuccess implements Action {
  public readonly type =
    EStudentsPerformanceActions.GetStudentsPerformancePeriodSuccess;

  constructor(public studentsPerformance: IPeriodResults) {}
}

export class GetStudentsPerformancePeriodFailure implements Action {
  public readonly type =
    EStudentsPerformanceActions.GetStudentsPerformancePeriodFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearStudentsPerformancePeriod implements Action {
  public readonly type =
    EStudentsPerformanceActions.ClearStudentsPerformancePeriod;
}

export class SetProbationaryForStudent implements Action {
  public readonly type = EStudentsPerformanceActions.SetProbationary;

  constructor(public studentId: number, public isProbation: boolean) {}
}

export type StudentsPerformanceActions =
  | GetStudentsPerformancePeriodRequest
  | GetStudentsPerformancePeriodSuccess
  | GetStudentsPerformancePeriodFailure
  | ClearStudentsPerformancePeriod
  | SetProbationaryForStudent;
